<div class="formly-field-wrap">
  @if(!options.formState.disabled && !field.props['disabled'] && !field.props['readonly']) {
    <input 
      class="active-input number-input" 
      [class.error]="formControl.invalid"
      type="{{field.props.type || 'date'}}"
      [min]="field.props.min || null"
      [max]="field.props.max || null"
      placeholder="{{field.props.placeholder || field.props.label || '' | translate}}"
      autocomplete="true"
      [(ngModel)]="localValue" 
      [formlyAttributes]="field"
      (change)="onChange($event)">
  } @else {
    <div [class]="(options.formState.showCompactViewWhenDisabled ? 'compact-' : '') + 'disabled-text'">
      {{formControl.value || "" | localeDate:(field.props['format'] || 'medium')}}
    </div>
  }
  <ng-template #fieldComponent></ng-template>
</div>